/**
 * 全局通用存储
 */
const getters = {
  /**
   * 客户相关信息
   */
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userId: state => state.user.userId,
  username: state => state.user.username,
  status: state => state.user.status,
  countryCode: state => state.user.countryCode,
  mobile: state => state.user.mobile,
  roles: state => state.user.roles,
  roleNames: state => state.user.roleNames,
  lastTime: state => state.user.lastTime,
  agentInfo: state => state.user.agentInfo,
  levels:state => state.user.levels,
  /**
   * 系统相关
   */
  systemName: state => state.system.name,
  openAgentSystem: state => state.system.openAgent,
  systemConfig: state => state.system.systemConfig,
  // 客户端访问方式（browser：一般浏览器，weixin：微信内打开，vlook：唯蜜星球打开）
  accessMode: state => state.system.accessMode,
  // 终端类型,android 安卓，ios苹果IOS
  deviceType: state => state.system.deviceType,
  // 经销商级别配置
  agentLevels: function () {
    return {
      220: "普通客户",
      135: "社区店",
      125: "形象店",
      105: "旗舰店",
      95: "联营店",
     
    };
  },
  // 经销商级别配置【旧体系】
  agentLevelsOld: function () {
    return {
      900: "董事经销商",
      1000: "总代经销商",
      1100: "一级经销商",
      1200: "二级经销商",
      1300: "三级经销商",
      1400: "特约经销商"
    };
  },
  // 类别对应保证金配置
  levelDeposit: function () {
    return {
      900: 30000,
      1000: 8000,
      1100: 3000,
      1400: 1500 // 特殊兼容保留特约的
    };
  },
  // 类别对应保证金配置【旧体系】
  levelDepositOld: function () {
    return {
      900: 20000,
      1000: 12000,
      1100: 8000,
      1200: 5000,
      1300: 3000,
      1400: 1500
    };
  },
  // 各类别补货全局配置
  levelOrderConfig: function () {
    return {
      900: {
        minNumber: 80, // 最小升级补货总数
        maxNumber: 160, //最大升级补货总数
        minTaskNumber: 50, // 最小月任务补货+完成月任务后可任意补货
        maxTaskNumber: 100, // 最大月任务补货
        maxNumber2: 30, //每月最多可补V2产品30箱
        maxNumber2Unit: "month", // 最多补货2.0计数单位：月
        price1: 198 * 10, //V1.0每箱金额
        price2: 256 * 10 // v2.0每箱金额
      },
      1000: {
        minNumber: 20, // 最小升级补货总数
        maxNumber: 40, //最大升级补货总数
        minTaskNumber: 0, // 无月任务
        maxTaskNumber: 0, // 无月任务
        maxNumber2: 6, //每次最多可补V2产品6箱
        maxNumber2Unit: "times", // 最多补货2.0计数单位：次
        price1: 238 * 10, //V1.0每箱金额
        price2: 309 * 10 // v2.0每箱金额
      },
      1100: {
        minNumber: 3, // 最小升级补货总数
        maxNumber: 6, //最大升级补货总数
        minTaskNumber: 0, // 无月任务
        maxTaskNumber: 0, // 无月任务
        maxNumber2: 1, //每次最多可补V2产品1箱
        maxNumber2Unit: "times", // 最多补货2.0计数单位：次
        price1: 358 * 10, //V1.0每箱金额
        price2: 446 * 10 // v2.0每箱金额
      }
    };
  },
  /**
   * 登录客户的微信原生数据
   */
  wxInfo: state => state.weixin.wxInfo
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js